<mat-card class="rankinglistentry" (click)="openRankingList()">
    <div class="rankinglistentry__content">
        <mat-icon class="rankinglistentry__icon">format_list_numbered</mat-icon>
        <div class="rankinglistentry__meta">
            <span class="rankinglistentry__name">{{List.Name}}</span>
            <span class="rankinglistentry__creator">{{List.createdBy}}</span>
        </div>
        <div class="rankinglistentry__rank">{{List.Ordinal}}</div>
    </div>
</mat-card>